function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.9 6H1.1C.5 6 0 5.5 0 4.9V1.1C0 .5.5 0 1.1 0h3.8C5.5 0 6 .5 6 1.1v3.8C6 5.5 5.5 6 4.9 6zM22.9 6h-3.8c-.6 0-1.1-.5-1.1-1.1V1.1c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM13.9 6h-3.8C9.5 6 9 5.5 9 4.9V1.1C9 .5 9.5 0 10.1 0h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM4.9 15H1.1C.5 15 0 14.5 0 13.9v-3.8C0 9.5.5 9 1.1 9h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM22.9 15h-3.8c-.6 0-1.1-.5-1.1-1.1v-3.8c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM13.9 15h-3.8c-.6 0-1.1-.5-1.1-1.1v-3.8c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM4.9 24H1.1C.5 24 0 23.5 0 22.9v-3.8c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM22.9 24h-3.8c-.6 0-1.1-.5-1.1-1.1v-3.8c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1zM13.9 24h-3.8c-.6 0-1.1-.5-1.1-1.1v-3.8c0-.6.5-1.1 1.1-1.1h3.8c.6 0 1.1.5 1.1 1.1v3.8c0 .6-.5 1.1-1.1 1.1z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;